import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation deleteServiceMenuSection($id: ID!) {
    deleteServiceMenuSection(id: $id)
  }
`);

export function useDeleteServiceMenuSection() {
  return useMutation(MUTATION, {
    refetchQueries: ['GetServiceDetail'],
  });
}
